import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Check } from 'lucide-react';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import Input, { Select, Textarea } from '../../components/ui/Input';
import Badge from '../../components/ui/Badge';
import { useToast } from '../../components/ui/Toast';
import { employees, stores, products } from '../../data/mockData';

export default function CreateTask() {
  const navigate = useNavigate();
  const toast = useToast();
  const [form, setForm] = useState({
    type: 'osg', title: '', description: '', priority: 'normal',
    assignedTo: '', storeId: '', dueDate: '', selectedProducts: [],
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const filteredEmployees = form.storeId
    ? employees.filter(e => e.storeIds.includes(form.storeId))
    : employees;

  const toggleProduct = (pid) => {
    set('selectedProducts', form.selectedProducts.includes(pid)
      ? form.selectedProducts.filter(p => p !== pid)
      : [...form.selectedProducts, pid]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title || !form.assignedTo || !form.storeId || !form.dueDate) {
      toast('Заполните все обязательные поля', 'error');
      return;
    }
    toast(`Задача "${form.title}" создана и назначена`, 'success');
    navigate('/tasks');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 800 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button variant="ghost" icon={<ArrowLeft size={15} />} onClick={() => navigate('/tasks')} size="sm">Назад</Button>
        <h1 style={{ fontSize: 20, fontWeight: 800, color: '#1A1A2E' }}>Создать задачу</h1>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Card title="Основная информация">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Select label="Тип задачи" value={form.type} onChange={e => {
                set('type', e.target.value);
                set('title', e.target.value === 'osg' ? 'Проверка ОСГ — ' : 'Выкладка — ');
              }} required options={[
                { value: 'osg', label: '🛡️ ОСГ Проверка' },
                { value: 'display', label: '📦 Выкладка' },
              ]} />
              <Select label="Приоритет" value={form.priority} onChange={e => set('priority', e.target.value)} required options={[
                { value: 'normal', label: 'Обычный' },
                { value: 'urgent', label: '🔥 Срочный' },
              ]} />
            </div>
            <div style={{ marginTop: 14 }}>
              <Input label="Название задачи" value={form.title} onChange={e => set('title', e.target.value)} placeholder="Проверка ОСГ — Молочный отдел" required />
            </div>
            <div style={{ marginTop: 14 }}>
              <Textarea label="Описание" value={form.description} onChange={e => set('description', e.target.value)} placeholder="Дополнительные инструкции..." rows={3} />
            </div>
          </Card>

          <Card title="Назначение">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Select label="Магазин" value={form.storeId} onChange={e => { set('storeId', e.target.value); set('assignedTo', ''); }} required placeholder="Выберите магазин" options={stores.map(s => ({ value: s.id, label: s.name }))} />
              <Select label="Сотрудник" value={form.assignedTo} onChange={e => set('assignedTo', e.target.value)} required placeholder="Выберите сотрудника" options={filteredEmployees.map(e => ({ value: e.id, label: `${e.name} (${e.role})` }))} />
              <div style={{ gridColumn: '1 / -1' }}>
                <Input label="Дедлайн" type="datetime-local" value={form.dueDate} onChange={e => set('dueDate', e.target.value)} required />
              </div>
            </div>
          </Card>

          <Card title="Товары">
            <div style={{ marginBottom: 12, fontSize: 12, color: '#6B7280' }}>
              Выбрано: <span style={{ fontWeight: 700, color: '#4A6CF7' }}>{form.selectedProducts.length}</span> товаров
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 8, maxHeight: 300, overflowY: 'auto' }}>
              {products.map(p => {
                const selected = form.selectedProducts.includes(p.id);
                return (
                  <div key={p.id} onClick={() => toggleProduct(p.id)} style={{
                    display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
                    borderRadius: 8, border: `1px solid ${selected ? '#4A6CF7' : '#E5E7EB'}`,
                    background: selected ? '#EEF2FF' : '#fff', cursor: 'pointer',
                    transition: 'all 0.15s',
                  }}>
                    {selected && <Check size={14} color="#4A6CF7" style={{ flexShrink: 0 }} />}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 500, fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</div>
                      <div style={{ fontSize: 11, color: '#8E8E93' }}>{p.category}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Card>

          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <Button variant="secondary" onClick={() => navigate('/tasks')}>Отмена</Button>
            <Button type="submit">Создать задачу</Button>
          </div>
        </div>
      </form>
    </div>
  );
}
